import { createAsyncThunk } from '@reduxjs/toolkit';
import { FetchOnboardingEmployeesResponse } from '../../../../types/b2tRatibiPlus';
import { PaginatedRequest } from '../../../../types/api';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';

export const fetchOnboardingEmployees = createAsyncThunk<
  FetchOnboardingEmployeesResponse,
  { companyId: number } & PaginatedRequest
>('onboardingEmployee/fetch-all', async (params) => {
  const response = await b2bThriftPlan.fetchOnboardingEmployees(params);
  return response;
});
